import { render } from "./error_404.vue?vue&type=template&id=39653e40&scoped=true"
import script from "./error_404.vue?vue&type=script&lang=js"
export * from "./error_404.vue?vue&type=script&lang=js"

import "./error_404.vue?vue&type=style&index=0&id=39653e40&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39653e40"]])

export default __exports__